import React, { useState } from "react";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";

import QuestionnaireEtatCivilModal from "./ModalQuestionnaire/QuestionnaireModal";
import QuestionnaireBienModal from "./ModalQuestionnaire/QuestionnaireBienModal";
import CoordonneesIntervenantsModal from "./ModalQuestionnaire/QuestionnaireIntervenantModal";
import InventaireBiensModal from "./ModalQuestionnaire/QuestionnaireInventaireModal";
import QuestionnaireDivorceModal from "./ModalQuestionnaire/QuestionnaireDivorceModal";
import QuestionnaireSuccessionModal from "./ModalQuestionnaire/QuestionnaireSuccessionModal";
import QuestionnaireLocataireModal from "./ModalQuestionnaire/QuestionnaireLocataireModal";
import QuestionnaireAcheteurModal from "./ModalQuestionnaire/QuestionnaireAcheteurModal";

/* ---------- Normalisation ---------- */
function normalizeKey(str = "") {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");
}

/* ---------- Switch robuste ---------- */
function getModalComponent(nom_document) {
  const key = normalizeKey(nom_document);

  switch (key) {
    case "questionnaire_etat_civil":
    case "questionnaire_de_connaissance":
      return QuestionnaireEtatCivilModal;

    case "questionnaire_bien":
      return QuestionnaireBienModal;

    case "coordonnees_des_intervenants":
      return CoordonneesIntervenantsModal;

    case "inventaire_liste_des_biens_immobiliers_et_mobiliers":
      return InventaireBiensModal;

    case "questionnaire_divorce":
      return QuestionnaireDivorceModal;

    case "questionnaire_succession":
      return QuestionnaireSuccessionModal;

    case "informations_locataires":
      return QuestionnaireLocataireModal;

      case "questionnaire_acheteur":
      return QuestionnaireAcheteurModal;

    default:
      return null;
  }
}

export default function ClientActionCard({
  nom_document,
  statut,
  action_id,
  affaire, 
}) {
  const [open, setOpen] = useState(false);
  const ModalComponent = getModalComponent(nom_document);
  const canOpen = statut === "fait" && !!ModalComponent;

  const isAffaireModal =
    normalizeKey(nom_document) === "questionnaire_divorce" ||
    normalizeKey(nom_document) === "questionnaire_succession";
//console.log("affaire dans CardInfoACompleter", affaire);
  return (
    <>
      <div className="bg-white rounded-lg p-4 mb-2">
        <h5><b>{nom_document}</b></h5>

        {statut === "à faire" && (
          <p className="text-sm font-regular leading-6 text-gray-500 flex items-center">
            <b>
              <XMarkIcon className="size-6 mr-1 inline-flex" />
              Pas encore renseigné
            </b>
          </p>
        )}

        {statut === "fait" && (
          <div className="flex flex-row justify-between items-center">
            <p className="text-sm font-semibold leading-6 text-green-500 mb-0">
              <CheckCircleIcon className="size-6 mr-1 inline-flex" />
              Informations ajoutées
            </p>

            <button
              className="btn-main w-fit"
              onClick={() => setOpen(true)}
              disabled={!canOpen}
            >
              Voir les informations
            </button>
          </div>
        )}

        {statut === "fait" && !ModalComponent && (
          <p className="mt-2 text-xs text-gray-400">
            ⚠️ Aucune modal configurée pour ce document
          </p>
        )}
      </div>

      {/* ✅ rendu modal */}
      {ModalComponent && (
        isAffaireModal ? (
          <ModalComponent
            open={open}
            onClose={() => setOpen(false)}
            affaire={affaire}
            title={nom_document}
          />
        ) : (
          <ModalComponent
            open={open}
            onClose={() => setOpen(false)}
            id_action={action_id}
            title={nom_document}
          />
        )
      )}
    </>
  );
}